import { render, staticRenderFns } from "./IndexCatalogue.vue?vue&type=template&id=0c88ad4e&"
import script from "./IndexCatalogue.vue?vue&type=script&lang=js&"
export * from "./IndexCatalogue.vue?vue&type=script&lang=js&"
import style0 from "./IndexCatalogue.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports